import axios, { employeeApi, extractData } from '@atheneum/api'
import { extendObservable } from 'mobx'
import moment from 'moment'

class EmployeeStore {
  constructor() {
    this.employeeData = {}

    extendObservable(this, {
      employee: null,
      loading: false,
      employees: [],
      positions: []
    })
  }

  init() {
    return this.fetchAllEmployees()
  }

  get(id) {
    this.loading = true

    return employeeApi
      .get(id)
      .then(employee => {
        this.employee = employee
        this.loading = false
        return employee
      })
      .catch(error => {
        console.error(error)
        this.error = error
        this.loading = false
      })
  }

  fetchAllEmployees() {
    return axios.get('/api/employee/list-all').then(res => {
      const dbName = 'ATH_Employees'
      const activeEmployees = res.data.filter(employee => employee.active)

      var request = indexedDB.open(dbName, 1)
      request.onerror = function (event) {
        console.error(`Could not connect with indexedDB: ${event}`)
      }
      request.onupgradeneeded = function (event) {
        var db = event.target.result
        var objectStore = db.createObjectStore('list-all', {
          autoIncrement: true
        })
        objectStore.createIndex('id', 'id', { unique: false })
        objectStore.transaction.oncomplete = function (event) {
          var employeeObjectStore = db
            .transaction('list-all', 'readwrite')
            .objectStore('list-all')
          activeEmployees.forEach(employee => employeeObjectStore.put(employee))
        }
      }

      const employeeList = extractData(res).map(e => {
        return {
          value: e.id,
          label: e.name,
          positionId: e.positionId,
          position: e.position,
          active: e.active,
          team: e.team,
          teamId: e.teamId,
          email: e.email
        }
      });

      this.employees.replace(employeeList)
    })
  }

  getEmployeesWithPositions(roles, userIds = []) {
    return this.employees.filter(e => {
      return (
        (e.active && roles.includes(e.positionId)) || userIds.includes(e.value)
      )
    })
  }

  getInitialsData(id) {
    if (this.employeeData[id]) return Promise.resolve(this.employeeData[id])
    return axios.get('/api/employee/' + id + '/initials-data').then(res => {
      this.employeeData[id] = extractData(res)
      return this.employeeData[id]
    })
  }

  loadPositions() {
    const { id } = this.employee

    employeeApi.getPositions(id).then(({ positions, permissions }) => {
      this.positions.replace(positions)
      // this allows us to avoid refreshing the entire employee in order to sync
      // permissions with the employee edit page or the permissions tab
      this.employee.permissions.replace(
        permissions.map(permission => permission.id)
      )
    })
  }

  updatePosition(positionData) {
    return employeeApi.updatePosition(positionData)
  }

  resolveMonthAndYear = newHireUntilValue => {
    const { employee } = this

    let date = moment().subtract(1, 'month')
    if (newHireUntilValue) {
      date = moment(newHireUntilValue)
    } else if (employee) {
      date = moment(employee.employee.created_at).subtract(2, 'month')
    }

    return date
  }

  update = employeeData => {
    employeeData.employee.newHireUntil = this.resolveMonthAndYear(
      employeeData.employee.newHireUntil
    ).format('YYYY-MM-DD')

    return employeeApi.updateEmployee(employeeData)
  }
}

export default EmployeeStore
